import { useCallback } from "react";
import { useQuery } from "@apollo/client";
import { useIsAuthenticated } from "@azure/msal-react";
import { FETCH_USER as fetchUser } from "../graphql/query/User";

const useUser = props => {
  const { skip = false } = props || {};
  const isAuthenticated = useIsAuthenticated();

  // Get token from localStorage (set by useMSAL)
  const token = localStorage.getItem("user:token");
  const shouldSkip = skip || !isAuthenticated || !token;

  const { data, error, loading } = useQuery(fetchUser({ permissions: {} }), {
    skip: shouldSkip,
  });

  const user = data?.user;
  const hasPermission = useCallback(
    (permissions = []) => {
      const checkPermissions = Array.isArray(permissions)
        ? permissions
        : (typeof permissions === "string" && [permissions]) || [];

      // bypass permission checker if there's no items to check
      if (!checkPermissions.length) return true;

      const userPermissions = user?.permissions || {};
      const flatUserPermissions = Object.values(userPermissions).reduce(
        (acc, item) => {
          const items = [];
          Object.keys(item).forEach(key => {
            if (item[key]) {
              items.push(key);
            }
          });
          return [...acc, ...items];
        },
        [],
      );
      let count = 0;
      checkPermissions?.forEach(permission => {
        if (flatUserPermissions.includes(permission)) {
          count += 1;
        }
      });
      if (count === checkPermissions?.length) {
        return true;
      } else {
        return false;
      }
    },
    [user],
  );

  const canUseCompany = useCallback(
    company => {
      const companyPermissions = user?.permissions?.COMPANY || {};
      const applyCompanyIds = companyPermissions?.COMPANY_APPLY_IDS;
      const allowedCompanyIds = Object.entries(
        companyPermissions?.COMPANY_IDS || {},
      )
        .filter(([, value]) => value === true)
        .map(([key]) => Number(key?.split?.("_")?.[1]))
        .filter(Number.isFinite);

      if (company?.active !== -1) {
        return false;
      }

      if (applyCompanyIds === false) {
        return allowedCompanyIds.includes(company?.id);
      }

      return true;
    },
    [user],
  );

  return {
    error,
    hasPermission,
    loading,
    user,
    canUseCompany,
  };
};

export default useUser;
